import React, { Component } from "react";

class Errors extends Component {
  render() {
    return (
      <div>
        <h5>Errors works!</h5>
      </div>
    );
  }
}

export default Errors;
